@let exchangeRate = exRateService.exRate$ | async;
@let exRate = exchangeRate?.RATE ?? 1;
<a
  (click)="handleSelect()"
  class="value-cell"
  [ngClass]="{
    changed: priceChangeFlash && cell.changed,
    'bg-lay': side === 'lay',
    'bg-back': side === 'back',
  }">
  <span class="value-price">
    {{ cell?.price || "-" }}
  </span>
  @if (showSize | async) {
    <span class="value-size">
      {{ cell.size ? (cell.size * exRate | number: "1.0-0") : "-" }}
    </span>
  }
</a>
